"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var FinanceWithdrawRequestsList_1 = require("./component/FinanceWithdrawRequestsList");
var PFinanceWithdrawsRequestsList = /** @class */ (function (_super) {
    __extends(PFinanceWithdrawsRequestsList, _super);
    function PFinanceWithdrawsRequestsList(props) {
        return _super.call(this, props) || this;
    }
    PFinanceWithdrawsRequestsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.brandsData.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: []
        }, function () {
            _this.props.brandsData.LoadData();
        });
    };
    PFinanceWithdrawsRequestsList.prototype.componentWillUnmount = function () {
        this.props.brandsData.UnSubscribe(this.SID_AB);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PFinanceWithdrawsRequestsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PFinanceWithdrawsRequestsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PFinanceWithdrawsRequestsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(FinanceWithdrawRequestsList_1.default, { data: this.props.data, state: this.props.state, onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), dlgMessage: this.props.dlgMessage }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PFinanceWithdrawsRequestsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PFinanceWithdrawsRequestsList.getPageDescription = function (state) {
        return {
            icon: "vote-yea",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_finance_withdraw_requests_list + "-id",
            itemTitle: "Заявки",
            route: routes_1.routes.page_finance_withdraw_requests_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PFinanceWithdrawsRequestsList;
}(React.Component));
exports.default = PFinanceWithdrawsRequestsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraw_requests_list/ui/PFinanceWithdrawRequestsList.tsx
// module id = 2445
// module chunks = 0